export enum PlotValueConverter {
    none = 0,
    firstChar = 1,
    lastChar = 2,
    dateYear = 3,
    dateMonth = 4,
    dateDayOfWeek = 5,
    dateDate = 6,
    dateHour = 7
}
export namespace PlotValueConverter{
    export function getName(value: PlotValueConverter): string {
        switch (value) {
            case PlotValueConverter.none:
                return "none";
            case PlotValueConverter.firstChar:
                return "firstChar";
            case PlotValueConverter.lastChar:
                return "lastChar";
            case PlotValueConverter.dateYear:
                return "dateYear";
            case PlotValueConverter.dateMonth:
                return "dateMonth";
            case PlotValueConverter.dateDayOfWeek:
                return "dateDayOfWeek";
            case PlotValueConverter.dateDate:
                return "dateDate";
            case PlotValueConverter.dateHour:
                return "dateHour";
        }
    }
}
